export const INFO_POPUP_MODAL_ID = 'widget-info-popup-modal';
